import { deserialize } from 'cerialize'

export class ActUnpaidCounterModel {
	@deserialize public on_partner_signing_single: number
	@deserialize public on_partner_signing_several: number
	@deserialize public amount_more_5k: number
}
